@if (ghosts.length !== 0) {
  <table class="table">
    <thead class="tw-h-15">
    <tr>
      <th>
        <div class="lines">
          <div class="headline"></div>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
      @if (!isCardDisplay()) {
        @for (ghost of ghosts; track $index) {
          <tr [style.height.px]="105">
            <td>
              <div class="lines">
                <div class="text"></div>
              </div>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
  @if (isCardDisplay()) {
    @let isSplit = isSplitscreen();
    <div
      class="tw-grid sm:tw-gap-5 sm:tw-p-5 tw-gap-3.5 tw-p-3.5 2xl:tw-grid-cols-3 lg:tw-grid-cols-2 tw-grid-cols-1"
      [ngClass]="{
    '6xl:tw-grid-cols-8 5xl:tw-grid-cols-7 4xl:tw-grid-cols-5 3xl:tw-grid-cols-4' : !isSplit,
    '6xl:tw-grid-cols-6 5xl:tw-grid-cols-5 4xl:tw-grid-cols-4' : isSplit
    }"
    >
      @for (ghost of ghosts; track $index) {
        <div class="lines">
          <div [style.height.px]="600"></div>
        </div>
      }
    </div>
  }

}
